import { Client } from '@termly-web/common'

export default Client
